<template>
  <div class="ms-resize-wrapper" ref="boxResize" :style="{'flex-direction': isHorizontal ? 'column' : 'row'}">
    <div class="content-left-wapper" ref="boxLeft" :style="styleWidthLeftComputed">
      <slot :explantToggle="explantToggle" name="contentLeft"> </slot>
    </div>
    <div class="lineResize" :class="{'border-right': hasLineResize}">
      <div
        :class="{'resize-left': isResizeLeft, 'resize-right': !isResizeLeft, 'resize-area': true}"
        @mousedown.prevent="resizeOn"
        @mouseup.prevent="resizeOff"
      ></div>
      <button
        v-if="toggleExplandButton"
        class="icon24"
        :class="{expand: explantToggle, 'toggle-left': !isResizeLeft, 'toggle-right': isResizeLeft}"
        @click="switchToggleLeft"
      ></button>
    </div>
    <div :class="`${classRightWrapper} content-right-wapper`" ref="boxRight" :style="styleWidthRightComputed">
      <slot :explantToggle="explantToggle" name="contentRight"> </slot>
    </div>
  </div>
</template>
<script>
import {defineComponent, onMounted, reactive, ref, getCurrentInstance, computed, watch, nextTick} from 'vue';
export default {
  name: 'msResizeWrapper',
  props: {
    // độ rộng nhỏ nhất có thể kéo
    minWidth: {
      default: 0,
      type: Number,
    },
    // độ rộng tối đa có thể kéo
    maxWidth: {
      default: 1000,
      type: Number,
    },
    // giá trị mặc định của width
    defaultWidth: {
      default: 0,
      type: Number,
    },
    // đơn vị nhập vào độ rộng(px, %)
    unitWidth: {
      default: `%`,
      type: String,
    },
    // có thể resize bên trái
    isResizeLeft: {
      default: false,
      type: Boolean,
    },
    // resize theo chiều ngang (chưa làm)
    isHorizontal: {
      default: false,
      type: Boolean,
    },
    // có nút mở rộng giá trị (left, right)
    toggleExplandButton: {
      default: true,
      type: Boolean,
    },
    // trạng thái mặc định của toggle
    defaultexplantToggle: {
      default: true,
      type: Boolean,
    },
    classRightWrapper: {
      default: '',
      type: String,
    },
    hasLineResize: {
      default: false,
      type: Boolean,
    },
  },
  emits: [
    'startResize',
    'stopResize',
    'explantToggle'
  ],
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    const width = ref(null);
    // hai biến này dùng để tính lại theo px khi nhập %
    const maxWidthx = ref(props.maxWidth);
    const minWidthx = ref(props.minWidth);
    const boxSizeWidth = ref(0);
    // vị trí đầu tiên khi bấm kéo
    const startPositionResize = ref(0);
    // vị trí con trỏ chuột dang kéo
    const endPositionResize = ref(0);
    // có đang trong trạng thái kéo
    const isResizeActive = ref(false);
    // nếu resize bên trái thì signResie = -1, bên phải = 1
    const signResize = props.isResizeLeft ? 1 : -1;
    // lưu trạng thái explan của toggle
    const explantToggle = ref(props.defaultexplantToggle);

    const styleWidthLeftComputed = computed(() => {
      var widthComputed = '';

      // lấy ra toàn bộ width của màn hình
      let widthScreen = window.innerWidth;
      // chuyển width từ px sang %
      let widthPercent = (width.value * 100) / widthScreen;

      if (props.isResizeLeft) {
        widthComputed = width.value != null ? `${widthPercent}%` : `${props.defaultWidth}${props.unitWidth}`;
        if (!explantToggle.value) {
          widthComputed = 0;
        }
      } else {
        widthComputed = 'unset';
      }

      var maxWidth = boxSizeWidth.value - width.value ?? 0;

      // chuyển width từ px sang %
      let maxWidthPercent = (maxWidth * 100) / widthScreen;

      return {
        width: widthComputed,
        'flex-grow': props.isResizeLeft ? 'unset' : 1,
        'max-width': props.isResizeLeft || !maxWidth || !explantToggle.value ? 'unset' : `${maxWidthPercent}%`,
        overflow: 'hidden',
      };
    });

    const styleWidthRightComputed = computed(() => {
      var widthComputed = '';

      // lấy ra toàn bộ width của màn hình
      let widthScreen = window.innerWidth;
      // chuyển width từ px sang %
      let widthPercent = (width.value * 100) / widthScreen;

      if (!props.isResizeLeft) {
        widthComputed = width.value != null ? `${widthPercent}%` : `${props.defaultWidth}${props.unitWidth}`;
        if (!explantToggle.value) {
          widthComputed = 0;
        }
      } else {
        widthComputed = 'unset';
      }
      var maxWidth = boxSizeWidth.value - width.value ?? 0;
      // chuyển width từ px sang %
      let maxWidthPercent = (maxWidth * 100) / widthScreen;

      return {
        width: widthComputed,
        'flex-grow': !props.isResizeLeft ? 'unset' : 1,
        'max-width': !props.isResizeLeft || !maxWidth || !explantToggle.value ? 'unset' : `${maxWidthPercent}%`,
        overflow: 'hidden',
      };
    });

    onMounted(() => {
      nextTick(() => {
        // Tính toán lại theo px nếu đang để unitWidth là %
        boxSizeWidth.value = proxy.$refs.boxResize.clientWidth;
        if (props.unitWidth == '%') {
          maxWidthx.value = Math.round((boxSizeWidth.value * props.maxWidth) / 100);
          minWidthx.value = Math.round((boxSizeWidth.value * props.minWidth) / 100);
          width.value = Math.round((boxSizeWidth.value * props.defaultWidth) / 100);
        } else {
          width.value = props.defaultWidth;
        }
      });
    });

    // theo dõi khi thay đổi vị trí kéo => thay đổi độ rộng
    watch(endPositionResize, newVal => {
      let newWidth = proxy.width + (endPositionResize.value - startPositionResize.value) * signResize;
      if (newWidth < minWidthx.value) {
        width.value = minWidthx.value;
      } else if (newWidth > maxWidthx.value) {
        width.value = maxWidthx.value;
      } else {
        startPositionResize.value = endPositionResize.value;
        width.value = newWidth;
      }
    });

    // Sửa lại đóng mở
    watch(() => proxy.defaultexplantToggle, newVal => {
      explantToggle.value = newVal;
    });

    /**
     * Sự kiện đang kéo chuột
     * Created by NNKiem 12/03/2024
     */
    const mouseMove = e => {
      endPositionResize.value = e.clientX;
      document.addEventListener('mouseup', resizeOff);
      if (!isResizeActive.value) {
        isResizeActive.value = true;
      }
    };

    /**
     * Sự kiện dừng kéo
     * Created by NNKiem 12/03/2024
     */
    const resizeOff = e => {
      isResizeActive.value = false;
      document.removeEventListener('mousemove', mouseMove);
      document.removeEventListener('mouseup', resizeOff);
      emit('stopResize');

    };

    /**
     * Sử lý sự kiện bắt đầu kéo
     * param sign để đánh dấu đang resize bên trái hay bên phải (1 phải -1 trái)
     * Created by NNKiem 12/03/2024
     */
    const resizeOn = e => {
      startPositionResize.value = e.clientX;
      document.addEventListener('mousemove', mouseMove);
      document.addEventListener('mouseup', resizeOff);
      emit('startResize');
    };

    /**
     * Sự kiện bấm Toggle Explant bên trái
     * Created by NNKiem 12/03/2024
     */
    const switchToggleLeft = function () {
      explantToggle.value = !explantToggle.value;
      emit('explantToggle');
    };

    return {
      width,
      resizeOn,
      resizeOff,
      mouseMove,
      explantToggle,
      switchToggleLeft,
      styleWidthLeftComputed,
      styleWidthRightComputed,
    };
  },
};
</script>
<style lang="scss" scoped>
.ms-resize-wrapper {
  overflow: hidden;
  display: flex;
  width: 100%;
  height: 100%;
  .lineResize {
    height: 100%;
    width: 0px;
    position: relative;
    .resize-area {
      cursor: col-resize;
      width: 10px;
      height: 100%;
      z-index: 2;
      position: absolute;
    }

    .toggle-right {
      cursor: pointer;
      outline: none;
      position: absolute;
      z-index: 3;
      top: calc(50% - 28px);
      right: -10px;
      height: 56px;
      width: 10px;
      padding: unset;
      border: none;
      background-color: $primary;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      &:hover {
        background-color: #0790fc;
      }
      &:before {
        content: '';
        position: absolute;
        background: transparent var(--image-sprites) no-repeat;
        height: 20px;
        width: 10px;
        top: auto;
        left: 0;
        background-position: -318px -74px !important;
      }
      &.expand {
        right: -5px;
        &:before {
          content: '';
          position: absolute;
          background: transparent var(--image-sprites) no-repeat;
          height: 20px;
          width: 10px;
          top: auto;
          left: 0;
          background-position: -318px -50px !important;
        }
      }
    }

    .toggle-left {
      cursor: pointer;
      outline: none;
      position: absolute;
      z-index: 3;
      top: calc(50% - 28px);
      left: -10px;
      height: 56px;
      padding: unset;
      width: 10px;
      border: none;
      background-color: $primary;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      &:hover {
        background-color: #0790fc;
      }
      &:before {
        content: '';
        position: absolute;
        background: transparent var(--image-sprites) no-repeat;
        height: 20px;
        width: 10px;
        top: auto;
        left: 0;
        background-position: -319px -50px !important;
      }
      &.expand {
        left: -4px;
        &:before {
          content: '';
          position: absolute;
          background: transparent var(--image-sprites) no-repeat;
          height: 20px;
          width: 10px;
          top: auto;
          left: 0;
          background-position: -319px -74px !important;
        }
      }
    }
  }
  .border-right {
    border-right: 1px solid $border;
  }
}
</style>
